export enum AuthPageModeType {
	INITIAL,
	SUCCESS
}
